import { Component, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyForm } from '@ngx-formly/core';

/**
 * Generic Form Component
 */
@Component({
  selector: 'era-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, FormlyForm],
})
export class FormComponent {
  readonly fields = input<FormlyFieldConfig[]>([]);
  readonly submitButtonText = input('Save');
  readonly submitButtonClass = input('btn btn-primary');
  readonly showSubmitButton = input(true);
  readonly formSubmit = output<Record<string, unknown>>();

  readonly formlyForm = viewChild(FormlyForm);

  form = new FormGroup({});
  model: Record<string, unknown> = {};

  onSubmit() {
    const currentModel = this.formlyForm()?.model || this.model;
    this.formSubmit.emit(currentModel);
  }
}
